import React from "react";
import Link from "gatsby-link";

export default () => (

        <div className="contact-card">
            <h1 style= {{ color: 'white'}}>
            Reservieren
            </h1>

            <p style= {{
                    color: 'white',
                    }}>Im einzigartigen Ambiente bieten wir auch Räume für Ihr Feier, Event oder Veranstaltung mit bis zu 140 Personen. Mit Bar und Bühnenbereich im hinteren Saal für grosse Anlässe.            <a style= {{ color: 'white'}} href="https://www.opentable.de/r/vietpho-cuisine-reservations-frankfurt-am-main?restref=166788&lang=de-DE">Über Opentable reservieren</a>&nbsp;
oder per E-Mail:                    </p>
            <article id="contact" className='active' >
            <form method="post" action="https://formspree.io/hallo@vietphocuisine.de" target="_blank">


            <div className="field half first">
                <label htmlFor="name">Name</label>
                <input type="text" name="name" id="name" />
            </div>
            <div className="field half">
                <label htmlFor="email">E-Mail Addresse</label>
                <input type="text" name="_replyto" id="email" />
            </div>
            <div className="field">
                <label htmlFor="message">Nachricht</label>
                <textarea name="message" id="message" rows="4"></textarea>
            </div>
            <ul className="actions">
                <li><input type="submit" value="Abschicken" className="special"/></li>
                <li id="reset"><Link to="/"><input type="reset" value="Zurück" /></Link></li>
            </ul>
            </form>

            <ul className="icons">

            <li><a style= {{ color: 'white'}} href="https://www.facebook.com/VietPho-Cuisine-334073757070790/" className="icon fa-facebook"><span className="label">Facebook</span></a></li>
            <li><a style= {{ color: 'white'}} href="https://www.instagram.com/vietpho_cuisine/" className="icon fa-instagram"><span className="label">Instagram</span></a></li>

            </ul>
            </article>
        </div>

)


// WEBPACK FOOTER //
// ./src/pages/contact.js